import { Box } from "@mui/material";
import { FC, PropsWithChildren } from "react";

export const PageActions: FC<PropsWithChildren> = ({ children }) => (
  <Box mt={3} display="flex">
    {children}
  </Box>
);
